export default "__VITE_ASSET__c8d398d4__"